import clsx from 'clsx';
import { useTabs } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { NavLink } from './navElement';
import { Icon, Spinner } from '@shared/widgets';
import SwapIcon from '@assets/icons/swap.svg';
import EarthIcon from '@assets/icons/earth.svg';
import CrownIcon from '@assets/icons/crown.svg';

interface NavigationProps {
  className?: string;
}

export const Navigation = (props: NavigationProps) => {
  const tabState = useTabs();

  return (
    <div className={clsx('w-full flex items-start  justify-start gap-2', props.className)}>
      <NavLink
        title='Between Insignia Account'
        icon={<Icon icon={<SwapIcon width='24' height='24' />} className='-rotate-90' color='white' />}
        to={RoutePaths.paymentsInsignia.onNavigate()}
      />
      <NavLink title='Other Bank Transfer' icon={<Icon icon={<EarthIcon />} color='white' />} to={RoutePaths.paymentsOther.onNavigate()} />
      {tabState.loading ? (
        <Spinner little />
      ) : (
        tabState.hasCard && (
          <NavLink title='Card Account Settlement' icon={<Icon icon={<CrownIcon />} color='white' />} to={RoutePaths.paymentsCard.onNavigate()} />
        )
      )}
    </div>
  );
};
